import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import Chip from "components/Chip";

export const getStatusColor = (color: number) => {
  switch (color ?? 0) {
    case 0:
      return "#7D1B1B";
    case 1:
      return "#ED0000";
    case 2:
      return "#B8006A";
    case 3:
      return "#FF5AC4";
    case 4:
      return "#FF642E";
    case 5:
      return "#D58C00";
    case 6:
      return "#FDAB3D";
    case 7:
      return "#F5D658";
    case 8:
      return "#401694";
    case 9:
      return "#332FD7";
    case 10:
      return "#119ECB";
    case 11:
      return "#2A8429";
    case 12:
      return "#38C435";
    case 13:
      return "#9CD326";
    case 14:
      return "#5F5C71";
    case 15:
      return "#C4C4C4";
    default:
      return "#119ECB";
  }
};

const StatusBadge: FC<Props> = ({
  status,
  onRemove,
  showName = false,
  small = false,
}) => {
  const getColor = () => {
    return getStatusColor(status?.Color);
  };

  if (showName) {
    return (
      <Chip
        small={small}
        background={getColor() + "3a"}
        color={"#1C1B1F"}
        element={
          <div className={styles.nameChip} title={status.Name}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_54775_65726"
                // style="mask-type:luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="20"
                height="20"
              >
                <rect width="20" height="20" fill="white" />
              </mask>
              <g mask="url(#mask0_54775_65726)">
                <path
                  d="M5 21V4H14L14.4 6H20V16H13L12.6 14H7V21H5Z"
                  fill={getColor()}
                />
              </g>
            </svg>

            {status.Name}
          </div>
        }
        onDelete={
          onRemove
            ? () => {
                onRemove(status);
              }
            : undefined
        }
      />
    );
  }

  return (
    <div
      title={status.Name}
      style={{
        background: "transparent",
        border: "solid 1px transparent",
      }}
      className={styles.tag}
    >
      <svg
        className={styles.bad}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_54775_65726"
          // style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect width="24" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_54775_65726)">
          <path
            d="M5 21V4H14L14.4 6H20V16H13L12.6 14H7V21H5Z"
            fill={getColor()}
          />
        </g>
      </svg>
    </div>
  );
};

export default StatusBadge;
